const BASE_URL =  "moonlightcdn.imgix.net" 

export const imageUrl = (url: string, width?: number, quality?: number) => {
    if (url.includes(".mp4")) return "/images" + url.split(".mp4").join(".gif");
    return `https://${BASE_URL}${url}?w=${width}&auto=format`
}

export const mp4Url = (url: string, res: "high" | "medium" | "low") => {
    return `https://${BASE_URL}${url}?fm=mp4&res=${res}`
}